import { Link } from "@tanstack/react-router";
import { Button, Container, Paper, Skeleton, Stack, Text, Title } from "@mantine/core";
import { IconArrowLeft, IconLayoutDashboard, IconLogin, IconUserCog } from "@tabler/icons-react";
import { AnchorLink } from "./AnchorLink";
import { useAuthStateQuery } from "../hooks/useAuthState";

/** Full-page not found when no app layout matched (e.g. unknown top-level path). */
export function RootNotFound() {
  const { data: authState, isPending } = useAuthStateQuery();

  return (
    <Container size="sm" py={60}>
      <Stack gap="xl" maw={380} mx="auto" align="stretch">
        <AnchorLink
          to="/"
          display="flex"
          style={{ alignItems: "center", gap: 4, alignSelf: "flex-start" }}
          size="sm"
        >
          <IconArrowLeft size={18} />
          Back to My Organisations
        </AnchorLink>

        <Stack gap="xs">
          <Title order={2}>Page not found</Title>
          <Text c="dimmed" size="sm" lh={1.6}>
            This URL does not match anything in the admin portal. Use one of the options below to
            continue.
          </Text>
        </Stack>

        <Paper withBorder p="lg" radius="md" shadow="sm" maw={380} w="100%" bg="dark.7">
          <Stack gap="sm">
            <Button
              component={Link}
              to="/"
              fullWidth
              size="md"
              leftSection={<IconLayoutDashboard size={18} />}
            >
              Return home
            </Button>
            {isPending ? (
              <Skeleton height={42} radius="md" />
            ) : authState ? (
              <Button
                component={Link}
                to="/account"
                fullWidth
                size="md"
                variant="light"
                leftSection={<IconUserCog size={18} />}
              >
                Account settings
              </Button>
            ) : (
              <Button
                component={Link}
                to="/login"
                fullWidth
                size="md"
                variant="light"
                leftSection={<IconLogin size={18} />}
              >
                Sign in
              </Button>
            )}
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
}
